export type ProductsTotalStatus = 'loading' | 'error' | 'ready';

// `total` is null until the first response arrives. After that it keeps the last total, so a refetch
// does not bring the loading state back. An undefined total is a response with an empty payload.
export const getProductsTotalStatus = (total: number | null | undefined, error: unknown): ProductsTotalStatus => {
    if (error) return 'error';
    if (total === null) return 'loading';

    return 'ready';
};
